import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DataRegions } from '../workflow/beneficiaries-form/commons/interfaces/beneficiaries-form.interface';

@Injectable({
  providedIn: 'root',
})
export class UtilsNotificationService {
  getCurrentDateFormatted(): string {
    const today = new Date();
    return this.formatDate(today);
  }

  addDaysToDate(days: number): string {
    const result = new Date();
    result.setDate(result.getDate() + days);
    return this.formatDate(result);
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatDateAlternative(date: string): string {
    const year = date.substring(0, 4);
    const month = date.substring(5, 7);
    const day = date.substring(8, 10);
    return `${day}-${month}-${year}`;
  }

  generateRandomNumber(digits: number): number {
    return (new Date().getMilliseconds());
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const key = event.key;

    // Permitir solo números, '-', y 'k' o 'K'
    const regex = /^[0-9kK\-\.]$/;
  
    if (key.length === 1 && !regex.test(key)) {
      return false;
    }
    return true;
  
  }
  
  formatDateToday(){
    const todayDate = new Date();
    const year = todayDate.getFullYear();
    const month = (todayDate.getMonth() + 1).toString().padStart(2, '0');
    const day = todayDate.getDate().toString().padStart(2, '0');
     return `${year}-${month}-${day}`;
  }



  formatDateXDaysFromToday(days: number): string {
    const todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + days);
    
    const year = todayDate.getFullYear();
    const month = (todayDate.getMonth() + 1).toString().padStart(2, '0'); // Ensure format 'MM'
    const day = todayDate.getDate().toString().padStart(2, '0'); // Ensure format 'DD'

    return `${year}-${month}-${day}`;
}

  
  maxDateValidator(maxDate:string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {      
      if (!control.value) {
        return null; 
      }
      const controlDate = new Date(control.value);     
      const maxDateObj = new Date(maxDate);  
      if(controlDate > maxDateObj ){
        return  { 'maxDate': { value: control.value }}
      }
       return null ;
   };
  }

  minDateValidator(days: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null; 
      }
  
      const controlDate = new Date(control.value);
      
      const minDate = new Date();
      minDate.setDate(minDate.getDate() - days);
  
      if (controlDate < minDate) {
        return { 'minDate': { value: control.value } }; 
      }
  
      return null; 
    };
  }
   
   getMinDate(): string {
      const fecha = new Date();
      fecha.setDate(fecha.getDate() - 90);
      return fecha.toISOString().split('T')[0];
    }
  
  
  getLast9Digits(phoneNumber: string): string {
    return phoneNumber.length <= 9 ? phoneNumber : phoneNumber.slice(-9);
  }
  montoValidator(controlName: string, matchingControlName: string): ValidatorFn {   
    return (element: AbstractControl): ValidationErrors | null => {
      const monto_solicitado = element.get(controlName)?.value;        
      const monto_documento = element.get(matchingControlName)?.value;
      if (!monto_solicitado || !monto_documento) {
        return null;
      }
      if (parseInt(monto_solicitado) > parseInt(monto_documento)) {
        return { montoInvalid: true };
      }
      return null;
    };
  }

  rutValidator(control: AbstractControl): ValidationErrors | null {
    const rutPrueba: string = control.value;
    
    if (rutPrueba !== null && rutPrueba !== undefined && rutPrueba !== "") {
      // Elimina puntos y luego separa el RUT en el número base y el dígito verificador
      const rutSinPuntos = rutPrueba.replace(/\./g, '');
      const rutArr: string[] = rutSinPuntos.split('-');
  
      if (rutArr.length !== 2) {
        return { miValidacion: true };
      }
  
      const firtsPartRut = rutArr[0].split('').map(Number).reverse();
      const cadena_fija = [2, 3, 4, 5, 6, 7];
      const resultado = [];
  
      for (let i = 0; i < firtsPartRut.length; i++) {
        const multiplicacion = firtsPartRut[i] * cadena_fija[i % cadena_fija.length];
        resultado.push(multiplicacion);
      }
  
      const sumaArrResultados = resultado.reduce((a, b) => a + b, 0);
      // Módulo 11
      const divisionModulo = Math.floor(sumaArrResultados / 11);
      const resultadoMultipModulo = divisionModulo * 11;
      const valorAbsoluto = sumaArrResultados - resultadoMultipModulo;
      const digitoVerificador = 11 - valorAbsoluto;
  
      const esValido =
        digitoVerificador.toString() === rutArr[1] ||
        (digitoVerificador === 11 && rutArr[1] === '0') ||
        (digitoVerificador === 10 && (rutArr[1] === 'k' || rutArr[1] === 'K'));
  
      return esValido ? null : { miValidacion: true };
    } else {
      return { miValidacion: true };
    }
  }

  genderBeneficiare(numSexo: string, genders: any) {
    for (const sexo of genders) {
      if (sexo.id.includes(numSexo)) {
        return sexo.name;
      }
    }
    return null;
  }
 
 optionCommune(selectRegion: string, listregion: DataRegions[], selectedComuna: any[]) {
  if (selectedComuna.length !== 0) {
    selectedComuna = [];
  }else{
    const selectedRegion = listregion.find(reg => reg.regionName === selectRegion);
    if (selectedRegion) {
      selectedComuna = selectedRegion.communes;
      return selectedComuna;
    }
  }
    return selectedComuna;
  }

  bankBeneficiare(numBanks: string, banks:any) {
    for (const bank of banks) {
      if (bank.id === parseInt(numBanks)) {
        return bank.name;
      }
    }
  }

  accountTypeBeneficiare(codAccount: string, accountTypes:any) {
    if(codAccount !== ""){
      for (const cta of accountTypes) {
      if (cta.id === parseInt(codAccount)) {
        return cta.name;
      }
    }
    }return ""  
  }

  statusMarital(numMarital: string, maritalStatus:any ) {
    for (const status of maritalStatus) {
      if (status.id.includes(numMarital)) {
        return status.name;
      }
    }
    return null;
  }

  formatDateSAP(date: string): string {
    const day = date.slice(-2);
    const month = date.slice(4, 6);
    const year = date.slice(0, 4);
    const newfecha = day + '-' + month + '-' + year;
    return newfecha;
  }

  encryptRut(rut: string): string {
    const encodedRut = btoa(encodeURIComponent(rut));
    return encodedRut;
  }
  
  decryptRut(encryptedRut: string): string {
    const decodedRut = decodeURIComponent(atob(encryptedRut));
    return decodedRut;
  }

  transformFormSeguroSaludDental(formDataSaludDental: any): any {
    let index = 1;
    const transform: any = {};
    for (const key in formDataSaludDental) {
    if (formDataSaludDental.hasOwnProperty(key)) {
        transform[key] = {
        index:index++,
        valor: formDataSaludDental[key],
        };
    }
    }
    return transform;
}
formatearFecha(fechita: string): string {
  if (fechita.length !== 0) {
    const fecha = fechita.split("-")
    const dia= fecha[2]
    const mes = fecha[1]
    const año = fecha[0]
    return `${dia}-${mes}-${año}`;
  } else {
    return "";
  }
}

formatearFecha2(fechita: string): string {
  if (fechita.length !== 0) {
    const fecha = new Date(fechita);
    const dia: string = ('0' + fecha.getDate()).slice(-2);
    const mes: string = ('0' + (fecha.getMonth() + 1)).slice(-2);
    const año: number = fecha.getFullYear();
    return `${dia}-${mes}-${año}`;
  } else {
    const vacio = '';
    return vacio;
  }
}

    minDateYearsValidator(years: number): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value) {
          return null;
        }

        const controlDate = new Date(control.value);
        // Normalizamos horas para evitar problemas por huso horario
        controlDate.setHours(0, 0, 0, 0);

        const cutoff = new Date();
        cutoff.setFullYear(cutoff.getFullYear() - years);
        cutoff.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Si la fecha está en el futuro, consideramos error de maxDate (debe manejar maxDateValidator también)
        if (controlDate > today) {
          return { 'maxDate': { value: control.value } };
        }

        // Si la fecha es más reciente que el corte (es decir, tiene menos de `years` años), es inválida
        if (controlDate > cutoff) {
          return { 'minDateYears': { value: control.value } };
        }

        // Fecha válida (es igual o anterior al corte)
        return null;
      };
    }

    anniversaryAllowedValidator(allowedYears: number[], windowDays: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const marriageDate = new Date(control.value);
      marriageDate.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let foundExpired = false;

      for (const years of allowedYears) {
        const anniversary = new Date(marriageDate);
        anniversary.setFullYear(anniversary.getFullYear() + years);
        anniversary.setHours(0, 0, 0, 0);

        const lastAllowed = new Date(anniversary);
        lastAllowed.setDate(lastAllowed.getDate() + windowDays);
        lastAllowed.setHours(23, 59, 59, 999);

        // Caso válido: hoy está entre aniversario y aniversario + windowDays
        if (today >= anniversary && today <= lastAllowed) {
          return null;
        }

        // Si hoy es mayor que lastAllowed, hubo un aniversario permitido pero expiró la ventana
        if (today > lastAllowed) {
          // Sólo marcamos expired si el aniversario ya ocurrió (es decir anniversary <= today)
          if (today >= anniversary) {
            foundExpired = true;
          }
        }

        // Si today < anniversary => aún no llegó ese aniversario, seguimos buscando otros allowedYears
      }

      if (foundExpired) {
        return { 'anniversaryExpired': { value: control.value } };
      }

      // Si no se encontró ningún aniversario válido ni expirado, entonces no es un año permitido
      return { 'anniversaryNotAllowedYear': { value: control.value } };
    };
  }

  cleanRut(rut: string): string {
    let cleanValue = rut.replace(/\./g, '');
    cleanValue = cleanValue.replace(/\s+/g, '');
    if (!cleanValue.includes('-') && cleanValue.length > 1) {
      const cuerpo = cleanValue.slice(0, -1);
      const dv = cleanValue.slice(-1);
      cleanValue = `${cuerpo}-${dv}`;
    }
    return cleanValue;
  }


}
